import React from 'react';
import { Modal, Button, TextArea, Message, Form } from 'semantic-ui-react';
import './ViewKey.css';

class ViewKey extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      open: props.open,
      privateKey: props.privateKey,
      issuer: props.issuer,
      token: props.token,
      keyNumber: props.keyId
    }
  }

  componentWillReceiveProps(nextProps) {
    this.setState({
      open: nextProps.open,
      privateKey: nextProps.privateKey,
      publicKey: nextProps.publicKey,
      issuer: nextProps.issuer,
      token: nextProps.token
    })
  }

  handleClose = () => {
    this.setState({ open: false });
    if (this.props.onClose) {
      this.props.onClose();
    }
  };

  render() {
    let privateKey = '';
    let token = '';
    let header = 'Key Details';

    if (this.state.privateKey) {
      privateKey = <div>
        <h3>Private Key</h3>
        <Message warning>
          <p>This is the only time you will have access to your private key here, please copy and save it securely!</p>
        </Message>
        <TextArea value={this.state.privateKey} rows={10} className="large"/>
        <div className="spacer"></div>
      </div>
      header = 'New Key Details';
    }

    if (this.state.token) {
      token = <div>
        <h3>Sample Developer Token</h3>
        <Form.Input type="text" value={this.state.token} className="large"/>
      </div>
    }

    return (
      <div>
        <Modal open={this.state.open} onClose={this.handleClose}>
          <Modal.Header>{header}</Modal.Header>
          <Modal.Content scrolling>
            <h3>Issuer</h3>
            <Form.Input type="text" value={this.state.issuer} className="large"/>
            {token}
            {privateKey}
            <div>
            <h3>Public Key</h3>
            <TextArea value={this.props.publicKey} rows={10} className="large" />
            </div>
          </Modal.Content>
          <Modal.Actions>
            <Button primary onClick={this.handleClose}>
              Close
            </Button>
          </Modal.Actions>
        </Modal>
      </div>
    );
  }
}

export default ViewKey;


// WEBPACK FOOTER //
// ./src/ViewKey.js